import { RoutesType } from 'Shared/Routes';
import {VenueRoutes} from 'Shared/routes/VenueRoutes';


//TODO delete this later if no special routes or pages required

export class IndieIslandRoutes extends VenueRoutes
{
	frontend()
	{
		return ({
			...super.frontend(),
		}) as RoutesType;
	}

	backend()
	{
		return ({
			...super.backend(),
		}) as RoutesType;
	}
}

